'use client';
import { SvgIcon } from '@/components/SvgIcon';
import { passButtonIcons } from '@/components/atoms/Button/utils';
import LinkButton from '@/components/atoms/LinkButton';
import { useCurrentExperiment } from '@/lib/experimentation';
import { track } from '@/lib/tracker';
import arrowRightSrc from '~/icons/arrow-right.svg';
import { useModernLayoutContext } from './Context';

const ModernVariantCTA = () => {
  const { activeSlideIndex, slides } = useModernLayoutContext();
  const experiment = useCurrentExperiment();

  const activeCTA = slides[activeSlideIndex]?.cardCta ?? null;
  if (!activeCTA) return null;

  const trackCtaClick = () => {
    if (!activeCTA) return;

    try {
      const eventPayload = {
        text: activeCTA.text,
        url: activeCTA.url,
        is_in_experiment_page: !!experiment,
        ...(experiment && {
          exp_experiment_id: experiment.flagId,
          variant_id: experiment.variant,
        }),
      };

      track('homepage_hero_modern_variant_cta_click', eventPayload);
    } catch {}
  };

  return (
    <LinkButton
      {...activeCTA}
      {...passButtonIcons({
        ...activeCTA,
        fallbackIcon: {
          rightSection: <SvgIcon src={arrowRightSrc} className='size-5 ml-2' />,
        },
      })}
      href={activeCTA.url ?? ''}
      onClick={trackCtaClick}
      classNames={{
        root: 'absolute bottom-6 right-6 z-40 px-4',
      }}
      variant={activeCTA.variant || 'outlined'}
      color={activeCTA.color || 'secondary'}
    >
      {activeCTA.text}
    </LinkButton>
  );
};

export default ModernVariantCTA;
